export default __webpack_public_path__ + "static/media/as-3.a13b969d.png";